import { OfflineBanner } from "@/components/layout/OfflineBanner";
import { CanonicalLink, PageMeta } from "@/components/layout/Seo";
import { Outlet, useLocation } from "react-router-dom";
import { GlassNavbar } from "@/components/layout/GlassNavbar";
import { MobileBottomNav } from "@/components/layout/MobileBottomNav";
import { SiteFooter } from "@/components/layout/SiteFooter";
import { useTabBarVisible } from "@/components/layout/chrome";
import { CompareTray } from "@/features/compare/CompareTray";
import { InstallBanner, InstallGuide } from "@/features/pwa";
import { cn } from "@/lib/cn";
import { usePageTransition } from "@/motion/usePageTransition";

/**
 * Customer-facing shell. Desktop: glass navbar + footer. Phones and the installed app: an app-style
 * top bar, the tab bar, and no footer (its links live in Account → More). Pages keep room at the
 * bottom for the tab bar (`--tabbar-h`) so it never covers the last row.
 */
export function StoreLayout() {
  const { pathname } = useLocation();
  const ref = usePageTransition<HTMLElement>(pathname);
  const tabBar = useTabBarVisible();
  return (
    <div className={cn("grain relative flex min-h-dvh flex-col overflow-x-clip", tabBar && "pb-[calc(var(--tabbar-h)+16px)]")}>
      <PageMeta title="RealityStore" />
      <CanonicalLink />
      <OfflineBanner />
      <GlassNavbar />
      <main id="main" ref={ref} className="relative min-w-0 flex-1">
        <Outlet />
      </main>
      <SiteFooter />
      <CompareTray />
      <InstallBanner />
      <InstallGuide />
      <MobileBottomNav />
    </div>
  );
}
